import { DinamicFormRefValues } from "../../../../../../../../../components/dynamicFormRef/types";
import { Item } from "../../../../../../../../../utils/types/generals";
import { OptionActionSavePayload } from "../../../../../../../components/optionActions/types"
import { typeConfigs } from "../constants"
import { CanSeeConfig, ConfigType, DetailConfig, Question } from "../types"

const formatOpenConfig = ({ id, name, questionData, indexSection, answerList, questionListDefault, configGeneral }: {
    id: Array<string> | null;
    name: ConfigType
    indexSection: number
    questionData: Record<string, DinamicFormRefValues>
    questionListDefault?: Question[]
    answerList: any[]
    configGeneral: string | null
}): {
    optionAction: string
    canSeeConfig: CanSeeConfig
    detailConfig?: DetailConfig
    optionData?: OptionActionSavePayload
} => {


    let optionData: OptionActionSavePayload | undefined
    let optionAction: string = ''
    let canSeeConfig: CanSeeConfig = { actionPlan: false, evidence: false, reportFolio: false }
    let detailConfig: DetailConfig | undefined = undefined

    switch (name) {
        // case typeConfigs.section: {
        //     optionData = sectionData?.config ? JSON.parse((sectionData.config ?? '{}') as string) : undefined
        // OptionAction = 'section'
        //     setCannotSeeConfig({ actionPlan: false, evidence: false, reportFolio: false })
        //     break;
        // }
        case typeConfigs.questionData: {
            optionData = questionData?.config ? JSON.parse((questionData.config ?? '{}') as string) : undefined
            optionAction = 'questionData'
            canSeeConfig = { actionPlan: false, evidence: true, reportFolio: false }
            detailConfig = {
                id: [],
                labels: [`Sección ${indexSection + 1}`, `Pregunta ${(questionListDefault?.length ?? 0) + 1}`],
                title: 'Configuración de preguntas',
                description: String(questionData?.questionText ?? ''),
            }
            break;
        }
        case typeConfigs.answerData: {
            const idList = (id) as Array<string>
            const findAnswerIndex = answerList.findIndex(answer => answer.id == idList[0])
            const findAnswer = answerList[findAnswerIndex]
            optionData = findAnswer?.config ? JSON.parse((findAnswer.config ?? '{}') as string) : undefined
            optionAction = idList[0]
            canSeeConfig = { actionPlan: true, evidence: true, reportFolio: true, reincidence: true }
            detailConfig = {
                id: [],
                labels: [`Sección ${indexSection + 1}`, `Pregunta ${(questionListDefault?.length ?? 0) + 1}`, `Ítem ${findAnswerIndex + 1}`],
                title: 'Configuración de ítem',
                answer: String(findAnswer?.answer?.text ?? findAnswer?.answer ?? ''),
                description: String(questionData?.questionText ?? ''),
            }
            break;
        }
        case typeConfigs.answerDataWhitOutReincidence: {
            optionData = questionData?.config ? JSON.parse((questionData.config ?? '{}') as string) : undefined
            optionAction = 'questionData'
            canSeeConfig = { actionPlan: true, evidence: true, reportFolio: true, reincidence: false }
            detailConfig = {
                id: [],
                labels: [`Sección ${indexSection + 1}`, `Pregunta ${(questionListDefault?.length ?? 0) + 1}`],
                title: 'Configuración de preguntas',
                description: String(questionData?.questionText ?? ''),
            }
            break;
        }
        case typeConfigs.questionList: {
            const idList = (id) as Array<string>
            const findQuestionIndex = questionListDefault?.findIndex(question => question.id == idList[0])
            const findQuestion = questionListDefault?.[Number(findQuestionIndex)]
            optionData = findQuestion?.question?.config ? JSON.parse((findQuestion?.question?.config ?? '{}') as string) : undefined

            optionAction = idList[0]
            detailConfig = {
                labels: [`Sección ${indexSection + 1}`, `Pregunta ${Number(findQuestionIndex) + 1}`],
                title: 'Configuración de preguntas',
                description: findQuestion?.question?.questionText,
                id: []
            }
            canSeeConfig = { actionPlan: false, evidence: true, reportFolio: false }
            break;
        }
        case typeConfigs.questionListWhitAll: {
            const idList = (id) as Array<string>
            const findQuestionIndex = questionListDefault?.findIndex(question => question.id == idList[0])
            const findQuestion = questionListDefault?.[Number(findQuestionIndex)]
            optionData = findQuestion?.question?.config ? JSON.parse((findQuestion?.question?.config ?? '{}') as string) : undefined

            optionAction = idList[0]
            detailConfig = {
                labels: [`Sección ${indexSection + 1}`, `Pregunta ${Number(findQuestionIndex) + 1}`],
                title: 'Configuración de preguntas',
                description: findQuestion?.question?.questionText,
                id: []
            }
            canSeeConfig = { actionPlan: true, evidence: true, reportFolio: true, reincidence: false }
            break;
        }
        case typeConfigs.answerList: {
            const idList = (id) as Array<string>
            const findQuestionIndex = questionListDefault?.findIndex(question => question.id == idList[1])
            const findQuestion = questionListDefault?.[Number(findQuestionIndex)]
            const findAnswerIndex = findQuestion?.answer?.findIndex((answer: Item) => answer?.id == idList?.[0])
            const findAnswer = findQuestion?.answer?.[Number(findAnswerIndex)]
            optionData = findAnswer?.config ? JSON.parse((findAnswer.config ?? '{}') as string) : undefined
            optionAction = idList[0]
            detailConfig = {
                id: [],
                labels: [`Sección ${indexSection + 1}`, `Pregunta ${Number(findQuestionIndex) + 1}`, `Ítem ${Number(findAnswerIndex) + 1}`],
                title: 'Configuración de ítem',
                answer: (findAnswer?.answer?.text as string) ?? findAnswer?.answer ?? '',
                description: findQuestion?.question?.questionText
            }
            canSeeConfig = { actionPlan: true, evidence: true, reportFolio: true, reincidence: true }
            break;
        }
        case typeConfigs.answerDataGeneral: {
            if (Boolean(id?.length)) {
                const idList = (id) as Array<string>
                const findQuestionIndex = questionListDefault?.findIndex(question => question.id == idList[0])
                const findQuestion = questionListDefault?.[Number(findQuestionIndex)]
                optionData = findQuestion?.configGeneral ? JSON.parse((findQuestion?.configGeneral ?? '{}') as string) : undefined
                optionAction = idList[0]
                detailConfig = {
                    id: [],
                    labels: [`Sección ${indexSection + 1}`, `Pregunta ${Number(findQuestionIndex) + 1}`],
                    title: 'Configuración de ítem',
                    description: findQuestion?.question?.questionText,
                }
            } else {
                optionData = configGeneral ? JSON.parse(configGeneral ?? '{}') : undefined
                optionAction = 'answerDataGeneral'
            }
            canSeeConfig = { actionPlan: true, evidence: true, reportFolio: true, reincidence: true}
            break;
        }
    }
    return {
        optionAction,
        canSeeConfig,
        detailConfig,
        optionData
    }
}

export { formatOpenConfig }